import { Component , OnInit, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertDialogModel } from 'src/app/core/models/view-model';

@Component({
  selector: 'app-copy-dialog',
  templateUrl: './copy-dialog.component.html',
  styleUrls: ['./copy-dialog.component.scss']
})
export class CopyDialogComponent implements OnInit {
  selectedOption = '';
  constructor(@Inject(MAT_DIALOG_DATA) public alertDialog: AlertDialogModel, public dialogRef: MatDialogRef<CopyDialogComponent>,@Inject(MAT_DIALOG_DATA) public approveDialog: AlertDialogModel) {}

  ngOnInit(): void {}
  selectOption(option: string): void {
    this.selectedOption = option;
    this.dialogRef.close(this.selectedOption);
  }
}
